
namespace Matrix.Dashboards
{
    export interface ChartColorPickerOptions {

    }

    @Serenity.Decorators.registerEditor([Serenity.IStringValue, Serenity.IReadOnly])
    @Serenity.Decorators.element('<input type="text" />')
    export class ChartColorPicker extends Serenity.Widget<ChartColorPickerOptions> implements Serenity.IStringValue, Serenity.IReadOnly {

        constructor(input: JQuery) {
            super(input);

            input.spectrum({
                allowEmpty: true,
                showInput: true,
                showAlpha: true,
                showPalette: false,
                preferredFormat: 'hex'
            });

            var replacer = input.next('.sp-replacer').addClass('editor').css({
                'display': 'flex',
                'flex-direction': 'row'
            });
            replacer.children('.sp-preview').css('flex', '1 1 50%')
        }

        private _readOnly: boolean;

        get_readOnly(): boolean {
            return !!this._readOnly;
        }

        set_readOnly(value: boolean): void {
            this._readOnly = !!value;
            this.element.spectrum(!value ? 'enable' : 'disable');
        }

        get_value() {
            var t = this.element.spectrum('get');
            if (t == null)
                return null;

            return t.getAlpha() != 1 ? t.toRgbString() : t.toHexString();
        }

        set_value(value: string): void {
            if (!value)
                this.element.spectrum('set', null);
            else {
                this.element.spectrum('set', value);
            }
        }

    }
}
